import classNames from "classnames";
import styles from "./Fieldset.module.scss";
import { Flex } from "../flex";
import { AlertIcon } from "../icons";
import type { FieldsetTypes } from "./Fieldset.types";

const Fieldset = ({
  children,
  error = "",
  className,
  rootClassName,
  align = "start",
}: FieldsetTypes) => {
  return (
    <fieldset className={classNames(styles["comp"], rootClassName)}>
      {children && <div className={className}>{children}</div>}

      {error && (
        <Flex
          align={"center"}
          justify={align}
          gap={6}
          className={styles["comp__error"]}
        >
          <AlertIcon />
          <span>{error}</span>
        </Flex>
      )}
    </fieldset>
  );
};

export { Fieldset };
